import { createFileRoute } from "@tanstack/react-router"
import { BackofficeWhatsappRoutes } from "modules/backoffice/components/whatsappRoutes"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { BackofficeBlockedConversationReasonEnum } from "schema"
import { z } from "zod"

const SearchBackofficeWhatsappRoutesSchema = PaginationSearchSchema.merge(SearchQuerySchema).extend(
  {
    reason: z.enum(BackofficeBlockedConversationReasonEnum).optional(),
  },
)

export const Route = createFileRoute("/_base/_auth/backoffice/whatsappRoutes")({
  component: BackofficeWhatsappRoutes,
  validateSearch: (search: Partial<z.infer<typeof SearchBackofficeWhatsappRoutesSchema>>) =>
    SearchBackofficeWhatsappRoutesSchema.parse(search),
  loader: ({ route: { fullPath } }) =>
    new Crumb({
      fullPath,
      title: (t) => t("backoffice.whatsappRoutes.title"),
    }),
})
